import { createStore } from 'vuex';
import user from './user';
import everyDay from './everyDay';
import fileDetails from './fileDetails';
import vedioDetails from './vedioDetails'

export default createStore({
  modules: {
    user,
    everyDay,
    fileDetails,
    vedioDetails,
  }
});